@use "variables" as *;

.collectionCard {
  position: relative;
  width: 100%;
  .hoverButtonsStack {
    visibility: hidden;
    position: absolute;
    right: 0;
    margin: $spacing-s;
    z-index: 100;
  }
  &:hover .hoverButtonsStack {
    visibility: visible;
  }
}

.hoverButton {
  width: 30px;
  height: 30px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}

.collectionCardSkeleton {
  border-radius: 20px;
  margin: $spacing-s $spacing-s $spacing-s 30px;
}

.loadingDiv {
  width: 50px;
  padding-left: $spacing-m;
}

.contentCard {
  display: flex;
  position: relative;
  margin: $spacing-m;
  overflow: auto !important;
  border-radius: 12px !important;
}

.cardContainer {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-shrink: 1;
  flex-grow: 0;
}

.searchBar {
  width: 100%;
  justify-content: center;
}

.toolbarBox {
  flex-shrink: 0;
}
